export const authRoles = {
  ADMIN: 'Admin',
  SELLER: 'Seller',
  ESTIMATOR: 'Estimator',
}

export const roles = [
  {
    label: authRoles.ADMIN,
  },
  {
    label: authRoles.SELLER,
  },
  {
    label: authRoles.ESTIMATOR,
  },
]

export const statuses: Record<any, any> = {
  IN_PROCESS: 'status.IN_PROCESS',
  SENT_ON_TIME: 'status.SENT_ON_TIME',
  SENT_WRONG_TIME: 'status.SENT_WRONG_TIME',
  WON: 'status.WON',
  LOST: 'status.LOST',
  EXPIRED: 'status.EXPIRED',
  RECEIVED: 'status.RECEIVED',
  ACTIVED: 'status.ACTIVED',
  DRAFTED: 'status.DRAFTED',
  INACTIVED: 'status.INACTIVED',
  CANCELLED: 'status.CANCELLED',
  APPROVE: 'status.APPROVE',
  APPROVED: 'status.APPROVED',
  APPLIED: 'status.APPLIED',
  PENDING: 'status.PENDING',
  SENT: 'status.SENT',
  IN_TRANSIT: 'status.IN_TRANSIT',
  HIGH: 'priority.HIGH',
  LOW: 'priority.LOW',
  MEDIUM: 'priority.MEDIUM',
  HOT: 'status.HOT',
  DELETED: 'status.DELETED',
}

export const commentTypes = {
  ESTIMATION: 'ESTIMATION',
  SELLER: 'SELLER',
}

export const priorityStatus = {
  HIGH: 'priority.HIGH',
  LOW: 'priority.LOW',
  MEDIUM: 'priority.MEDIUM',
}

export const priorityDefault = [
  { id: 7, name: 'HIGH', color: '!bg-red-50 !text-red-600' },
  { id: 8, name: 'MEDIUM', color: '!bg-yellow-50 !text-yellow-600' },
  { id: 9, name: 'LOW', color: '!bg-green-50 !text-green-600' },
]

export const priorities: Record<any, string> = {
  7: 'pi pi-chevron-up text-red-500',
  8: 'pi pi-minus text-yellow-500',
  9: 'pi pi-chevron-down text-green-500',
}

export const defaultStatuses = {
  IN_PROCESS: 'IN_PROCESS',
  SENT_ON_TIME: 'SENT_TIME',
  SENT_WRONG_TIME: 'SENT_WRONG_TIME',
  WON: 'WON',
  LOST: 'LOST',
  EXPIRED: 'EXPIRED',
  RECEIVED: 'RECEIVED',
  ACTIVED: 'ACTIVED',
  DRAFTED: 'DRAFTED',
  INACTIVED: 'INACTIVED',
  DELETED: 'DELETED',
  CANCELLED: 'CANCELLED',
  APPROVE: 'APPROVE',
  APPROVED: 'APPROVED',
  APPLIED: 'APPLIED',
  PENDING: 'PENDING',
  SENT: 'SENT',
  IN_TRANSIT: 'IN_TRANSIT',
}

export const statusesList = Object.keys(defaultStatuses)

export const baseProps = {
  isOpen: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'add',
  },
}

export const months = {
  es: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
}

export const defaultPagination = {
  current_page: 1,
  from: 1,
  last_page: 1,
  per_page: 10,
  total: 0,
}

export const recordActions = {
  actived: 'actived',
  active: 'active',
  inactived: 'inactived',
  inactive: 'inactive',
  cancel: 'cancel',
  approve: 'approve',
  applied: 'applied',
  apply: 'apply',
  added: 'added',
  substracted: 'substracted',
  send: 'send',
  receive: 'receive',
  'in-transit': 'in-transit',
  show_history: 'history',
  show_payments: 'payments',
} as const

export const invitationStatuses = [
  { id: 1, name: 'IN_PROCESS', color: '!bg-orange-50 !text-orange-600' },
  { id: 2, name: 'SENT_ON_TIME', color: 'bg-green-50 text-green-600' },
  { id: 3, name: 'SENT_WRONG_TIME', color: 'bg-blue-50 text-blue-600' },
  { id: 4, name: 'WON', color: '!bg-yellow-50 !text-yellow-600' },
  { id: 5, name: 'LOST', color: 'bg-gray-50 text-gray-600' },
  { id: 6, name: 'EXPIRED', color: '!bg-indigo-50 !text-indigo-600' },
  { id: 12, name: 'HOT', color: '!bg-red-50 !text-red-600' },
  { id: 14, name: 'CANCELLED', color: '!bg-red-50 !text-red-600' },
]

export const defaultOrder = {
  icon: 'pi-arrow-up',
  name: 'Fecha de creación',
  value: 'created_at,asc',
}

export const availableCatalogs = {}
export const catalogsNames = {}

export const invitationStatusesIds = {
  in_progress: 1,
  sent_on_time: 2,
  sent_wrong_time: 3,
  won: 4,
  lost: 5,
  expired: 6,
  hot: 12,
  cancelled: 14,
}

export const cities = [{ id: 1, name: '' }]

export const statesUS = [
  { id: 1, name: 'Alabama', code: 'AL' },
  { id: 2, name: 'Alaska', code: 'AK' },
  { id: 3, name: 'Arizona', code: 'AZ' },
  { id: 4, name: 'Arkansas', code: 'AR' },
  { id: 5, name: 'California', code: 'CA' },
  { id: 6, name: 'Colorado', code: 'CO' },
  { id: 7, name: 'Connecticut', code: 'CT' },
  { id: 8, name: 'Delaware', code: 'DE' },
  { id: 9, name: 'Florida', code: 'FL' },
  { id: 10, name: 'Georgia', code: 'GA' },
  { id: 11, name: 'Hawaii', code: 'HI' },
  { id: 12, name: 'Idaho', code: 'ID' },
  { id: 13, name: 'Illinois', code: 'IL' },
  { id: 14, name: 'Indiana', code: 'IN' },
  { id: 15, name: 'Iowa', code: 'IA' },
  { id: 16, name: 'Kansas', code: 'KS' },
  { id: 17, name: 'Kentucky', code: 'KY' },
  { id: 18, name: 'Louisiana', code: 'LA' },
  { id: 19, name: 'Maine', code: 'ME' },
  { id: 20, name: 'Maryland', code: 'MD' },
  { id: 21, name: 'Massachusetts', code: 'MA' },
  { id: 22, name: 'Michigan', code: 'MI' },
  { id: 23, name: 'Minnesota', code: 'MN' },
  { id: 24, name: 'Mississippi', code: 'MS' },
  { id: 25, name: 'Missouri', code: 'MO' },
  { id: 26, name: 'Montana', code: 'MT' },
  { id: 27, name: 'Nebraska', code: 'NE' },
  { id: 28, name: 'Nevada', code: 'NV' },
  { id: 29, name: 'New Hampshire', code: 'NH' },
  { id: 30, name: 'New Jersey', code: 'NJ' },
  { id: 31, name: 'New Mexico', code: 'NM' },
  { id: 32, name: 'New York', code: 'NY' },
  { id: 33, name: 'North Carolina', code: 'NC' },
  { id: 34, name: 'North Dakota', code: 'ND' },
  { id: 35, name: 'Ohio', code: 'OH' },
  { id: 36, name: 'Oklahoma', code: 'OK' },
  { id: 37, name: 'Oregon', code: 'OR' },
  { id: 38, name: 'Pennsylvania', code: 'PA' },
  { id: 39, name: 'Rhode Island', code: 'RI' },
  { id: 40, name: 'South Carolina', code: 'SC' },
  { id: 41, name: 'South Dakota', code: 'SD' },
  { id: 42, name: 'Tennessee', code: 'TN' },
  { id: 43, name: 'Texas', code: 'TX' },
  { id: 44, name: 'Utah', code: 'UT' },
  { id: 45, name: 'Vermont', code: 'VT' },
  { id: 46, name: 'Virginia', code: 'VA' },
  { id: 47, name: 'Washington', code: 'WA' },
  { id: 48, name: 'West Virginia', code: 'WV' },
  { id: 49, name: 'Wisconsin', code: 'WI' },
  { id: 50, name: 'Wyoming', code: 'WY' },
]
export const shortMonths = {
  es: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  en: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
}

export const tableSortOptions: Record<any, any> = {
  'status.id': 'status_id',
  'priority.id': 'priority_id',
  delivery_date: 'delivery_date',
}
